import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Jak dlouho se čeká, než se celoobrazovkový loader ukáže.
 *
 * Krátká načtení spinner vůbec nezobrazí. Problikávající overlay působí jako zádrhel
 * a u vstupu do kurzu navíc překrýval přechodovou animaci stránky: detail kurzu hned
 * po otevření dotahuje kapitolu druhým požadavkem, jehož loader naskočil přesně přes
 * těch 180 ms příjezdu.
 *
 * 150 ms je pod hranicí, kdy se čekání začne vnímat jako čekání, a zároveň kratší než
 * příjezd stránky — u pomalejšího serveru se tedy loader stihne ukázat.
 */
const SHOW_AFTER_MS = 150;

@Injectable({
  providedIn: 'root'
})
export class PageLoaderService {

  private pageLoaderStatusSubject = new BehaviorSubject<boolean>(false);

  private pendingTimer?: ReturnType<typeof setTimeout>;

  get pageLoaderStatus$(): Observable<boolean> {
    return this.pageLoaderStatusSubject.asObservable();
  }

  constructor() { }

  /**
   * Ohlásí začátek načítání. Loader se ukáže až po prodlevě — když se stihne zavolat
   * `disablePageLoader()` dřív, uživatel žádný spinner neuvidí.
   *
   * Dvě souběžná načtení sdílejí jeden příznak, takže konec toho prvního schová loader
   * i tomu druhému. Tak se to chovalo i dřív; na nic v aplikaci to zatím nedopadá.
   */
  enablePageLoader(): void {
    if (this.pendingTimer || this.pageLoaderStatusSubject.value) {
      return;
    }

    this.pendingTimer = setTimeout(() => {
      this.pendingTimer = undefined;
      this.pageLoaderStatusSubject.next(true);
    }, SHOW_AFTER_MS);
  }

  disablePageLoader(): void {
    if (this.pendingTimer) {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = undefined;
    }

    if (this.pageLoaderStatusSubject.value) {
      this.pageLoaderStatusSubject.next(false);
    }
  }
}
